export const getFloors = (buildingId: number, buildings: any[]) => {
  const selectedBuilding = buildings?.find(
    (building) => buildingId === building?.id,
  );
  if (selectedBuilding) {
    let floors = [];
    for (let i = 1; i <= selectedBuilding?.floorCount; i++) {
      floors.push({ label: i.toString(), value: i });
    }
    return floors;
  } else {
    return [];
  }
};
